import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '../../../../../_metronic/helpers'
import { ChartModel } from '../../../../../_metronic/partials/widgets/charts/_models'
import { Guidance, GuidanceOption, GuidancesQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GET_GUIDANCE_URL = `${API_URL}/guidance/getguidance`
const GET_GUIDANCE_COUNT_CHART_URL = `${API_URL}/guidance/getguidancecountchart`
const GET_GUIDANCE_LESSON_COUNT_CHART_URL = `${API_URL}/guidance/getguidancelessoncountchart`
const GET_GUIDANCE_INDIVIDUAL_DISTRIBUTION_CHART_URL = `${API_URL}/guidance/getGuidanceIndividualDistributionChart`
const GET_GUIDANCE_FORM_RESULT_CHART_URL = `${API_URL}/guidance/getGuidanceFormResultsChart`
const GET_GUIDANCE_AREA_DISTRIBUTION_RATIO_CHART_URL = `${API_URL}/guidance/getGuidanceAreaDistributionRatioChart`
const GET_GUIDANCE_SUBFIELD_SCATTER_CHART_URL = `${API_URL}/guidance/getGuidanceSubfieldScatterChart`
const GET_GUIDANCE_RESULT_DECISION_CHART_URL = `${API_URL}/guidance/getGuidanceResultDecisionChart`
const GET_GUIDANCE_COMPARISON_CHART_URL = `${API_URL}/guidance/getGuidanceComparisonChart`
const GET_GUIDANCE_QUESTION_ANSWER_CHART_URL = `${API_URL}/guidance/getGuidanceQuestionAnswerChart`
const CREATE_GUIDANCE_URL = `${API_URL}/guidance/addguidance`
const UPDATE_GUIDANCE_URL = `${API_URL}/guidance/updateguidance`
const UPDATE_GUIDANCE_RESULT_URL = `${API_URL}/guidance/updateguidanceresult`
const DELETE_GUIDANCE_URL = `${API_URL}/guidance/deleteguidance`
const GET_GUIDANCES_URL = `${API_URL}/guidance/getguidances`
const GET_CUSTOMER_GUIDANCES_URL = `${API_URL}/guidance/getcustomerguidances`
const GET_GUIDANCE_OPTIONS_URL = `${API_URL}/guidance/getguidanceoptions`

const getGuidances = (query: string): Promise<GuidancesQueryResponse> => {
  return axios
    .get(`${GET_GUIDANCES_URL}?${query}`)
    .then((d: AxiosResponse<GuidancesQueryResponse>) => d.data)
}

const getGuidanceOptions = (query: string): Promise<GuidanceOption[]> => {
    return axios
        .get(`${GET_GUIDANCE_OPTIONS_URL}?${query}`)
        .then((d: AxiosResponse<GuidanceOption[]>) => d.data)
}

const getCustomerGuidances = (query: string): Promise<GuidancesQueryResponse> => {
  return axios
    .get(`${GET_CUSTOMER_GUIDANCES_URL}?${query}`)
    .then((d: AxiosResponse<GuidancesQueryResponse>) => d.data)
}

const getGuidanceById = (id: ID): Promise<Guidance | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_URL}/${id}`)
    .then((response: AxiosResponse<Response<Guidance>>) => response.data)
    .then((response: Response<Guidance>) => response.data)
}



const getGuidanceCountChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_COUNT_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceLessonCountChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_LESSON_COUNT_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceIndividualDistributionChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_INDIVIDUAL_DISTRIBUTION_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceFormResultsChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_FORM_RESULT_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceAreaDistributionRatioChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_AREA_DISTRIBUTION_RATIO_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceSubfieldScatterChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_SUBFIELD_SCATTER_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceResultDecisionChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_RESULT_DECISION_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}
const getGuidanceComparisonChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_COMPARISON_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const getGuidanceQuestionAnswerChart = (query: string): Promise<ChartModel | undefined> => {
  return axios
    .get(`${GET_GUIDANCE_QUESTION_ANSWER_CHART_URL}?${query}`)
    .then((response: AxiosResponse<Response<ChartModel>>) => response.data)
    .then((response: Response<ChartModel>) => response.data)
}

const createGuidance = (guidance: Guidance): Promise<Guidance | undefined> => {
  return axios
    .post(CREATE_GUIDANCE_URL, guidance)
    .then((response: AxiosResponse<Response<Guidance>>) => response.data)
    .then((response: Response<Guidance>) => response.data)
}

const updateGuidance = (guidance: Guidance): Promise<Guidance | undefined> => {
  return axios
    .put(`${UPDATE_GUIDANCE_URL}/${guidance.id}`, guidance)
    .then((response: AxiosResponse<Response<Guidance>>) => response.data)
    .then((response: Response<Guidance>) => response.data)
}

const updateGuidanceResult = (guidance: Guidance): Promise<Guidance | undefined> => {
  return axios
    .put(`${UPDATE_GUIDANCE_RESULT_URL}/${guidance.id}`, guidance)
    .then((response: AxiosResponse<Response<Guidance>>) => response.data)
    .then((response: Response<Guidance>) => response.data)
}

const deleteGuidance = (guidanceId: ID): Promise<void> => {
  return axios.delete(`${DELETE_GUIDANCE_URL}/${guidanceId}`).then(() => { })
}

const deleteSelectedGuidances = (guidanceIds: Array<ID>): Promise<void> => {
  const requests = guidanceIds.map((id) => axios.delete(`${DELETE_GUIDANCE_URL}/${id}`))
  return axios.all(requests).then(() => { })
}

export { getGuidances,getGuidanceOptions, getCustomerGuidances, deleteGuidance, getGuidanceCountChart, getGuidanceLessonCountChart,getGuidanceIndividualDistributionChart,getGuidanceFormResultsChart,getGuidanceAreaDistributionRatioChart,getGuidanceSubfieldScatterChart,getGuidanceResultDecisionChart,getGuidanceComparisonChart ,getGuidanceQuestionAnswerChart,deleteSelectedGuidances, getGuidanceById, createGuidance, updateGuidance, updateGuidanceResult }
